/* eslint-disable max-len */
const serviceContent = {
  HC: {
    title: 'Jasa Cleaning Service Yang Mengembalikan Keindahan Rumah Anda',
    subtitle: [
      'Dalam rutinitas sehari-hari yang sibuk, membersihkan rumah sering kali menjadi tugas yang terlupakan atau ditunda. Namun, kebersihan rumah adalah elemen penting dalam menciptakan lingkungan yang nyaman dan sehat untuk Anda dan keluarga. Inilah mengapa jasa cleaning service profesional hadir untuk meringankan beban Anda dan memastikan rumah tetap bersih, rapi, dan menyegarkan setiap saat.',
      'Kebersihan rumah bukan hanya soal tampilan rumah yang bagus, tetapi berkaitan erat dengan kesehatan dan kenyamanan keluarga. Debu, kotoran, dan kuman yang menumpuk di berbagai sudut rumah dapat menyebabkan alergi, infeksi, dan masalah kesehatan lainnya. Dengan menggunakan jasa home cleaning service secara teratur, anda dapat memastikan setiap bagian rumah anda dibersihkan dengan detail, meningkatkan kualitas udara dan kebersihan ruangan anda. Jika anda kebingungan mendapatkan orang yang bersedia menjadi cleaning service panggilan, kini hadir Halo Clean yang siap membantu anda membereskan rumah dengan hasil yang sempurna.',
      'Halo Clean adalah layanan bersih-bersih rumah panggilan yang membantu anda menyelesaikan pekerjaan rumah dengan mudah. Halo Clean menjadi home cleaning terbaik dalam urusan bersih-bersih rumah. Halo clean memberikan layanan terbaik yang patut untuk dicoba. Halo clean berbasis aplikasi bersih rumah dengan nama Halo Jasa yang dapat diunduh baik di Google Playstore atau Apps Store. Oleh karena itu, kemudahan akses ini menjadikan Halo Clean pilihan terbaik untuk jasa bersih rumah dengan harga yang terjangkau.',
      'Pekerjaan membersihkan rumah tidak hanya menyapu, tetapi ada beberapa pekerjaan tertentu diantaranya membuka fentilasi setiap ruangan baik di rumah, apartemen atau kantor, membersihkan ruangan, menata barang dengan menyimpannya di tempat asalnya, mengelap kaca, membersihkan debu, mengepel, menyalakan AC sehingga ruangan menjadi sejuk, menyemprotkan pengharum ruangan, dan membuang sampah. Semua pekerjaan ini cukup merepotkan jika dilakukan sendiri. Solusinya hanya satu, pesan Halo Clean buat rumah anda jadi bersih dan sehat.'
    ],
    detailContent: [
      {
        id: 1,
        title: 'Jenis-jenis Jasa Cleaning Service di Halo Jasa',
        subtitle: [
          'Halo Jasa adalah platform layanan yang terpercaya dan professional, menyediakan beragam jenis layanan terbaik diantaranya Halo Clean yang menyediakan layanan bersih-bersih rumah. Berikut ini beberapa paket di Halo Clean yang tersedia :'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Home Cleaning',
            subtitle: [
              'Layanan ini termasuk dalam pembersihan rumah yang meliputi membersihkan kamar mandi, kamar tidur, ruang dapur, ruang keluarga, dan ruang tamu. Layanan ini membantu anda menyelesaikan tugas rumah yang sangat banyak, jadi kamu tidak perlu repot-repot lagi membereskan rumah yang melelahkan ini.'
            ]
          },
          {
            id: 2,
            title: 'Apartemen atau Kost',
            subtitle: [
              'Layanan yang menyeluruh dan detail meliputi pembersihan sesuai ukuran unit kost atau apartemen anda baik 2 bedroom, 3 bedroom, atau lebih dari 3 bedroom. Dengan pemesanan paket layanan ini, anda tidak perlu khawatir apartemen atau kost tidak dirawat dengan baik, karena kami siap sedia kapanpun dimanapun anda membutuhkan cleaning service panggilan.'
            ]
          },
          {
            id: 3,
            title: 'Residensial',
            subtitle: [
              'Layanan ini untuk membersihkan pada area 2 kamar, 3 kamar, atau 4 kamar. Dengan selalu memperhatikan setiap detail yang membuat suasana kamar anda menjadi lebih sehat dan nyaman.'
            ]
          },
          {
            id: 4,
            title: 'Office Cleaning',
            subtitle: [
              'Layanan ini untuk pembersihan pada area kantor termasuk membersihkan ruang kerja, ruang meeting, dapur atau pantry, ruang tunggu, dan toilet atau WC. Dengan menggunakan jasa dari Halo Clean, dapat membuat seluruh ruangan menjadi lebih bersih dan sehat serta meningkatkan produktifitas karyawan.'
            ]
          }
        ]
      },
      {
        id: 2,
        title: 'Kriteria Memilih Jasa Cleaning Service',
        subtitle: [
          'Menggunakan suatu jasa membersihkan rumah panggilan ke rumah sangat penting untuk mempertimbangkan terlebih dahulu hal-hal yang berkaitan dengan penyedia jasa yang akan memberikan pelayanan. Berikut beberapa kriteria dalam memilih suatu jasa membersihkan rumah :'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Reputasi Perusahaan',
            subtitle: [
              'Untuk anda yang pertama kali memakai cleaning service panggilan ke rumah, anda harus pastikan terlebih dahulu reputasi perusahaan yang akan anda digunakan. Hal ini dilakukan untuk memastikan proses pengerjaan cleaning service sesuai dengan apa yang sudah anda order melalui aplikasi. Halo Clean selalu melakukan pelayanan terbaik dan anda dapat melihat reputasi perusahaan Halo Jasa yang dapat meyakinkan anda bahwa Halo Clean adalah satu-satunya alternatif pilihan terbaik. Jadi tidak perlu ragu lagi dengan layanan Halo Clean yang memberikan layana home cleaning berkualitas dan professional untuk kenyamanan rumah anda.'
            ]
          },
          {
            id: 2,
            title: 'Keahlian dan Pengalaman',
            subtitle: [
              'Keahlian melakukan pekerjaan rumah dan pengalaman yang luas, dengan memberikan pelayanan yang baik karena dengan demikian kepercayaan anda akan ada terhadap suatu jasa. Termasuk pada Halo Clean yang memiliki kemampuan bersih-bersih yang efektif, maka pengerjaan pembersihan rumah kamu dari debu, kotoran dan polusi yang masuk ke rumah akan hilang. Selain itu, Halo Clean juga sudah terpercaya dan memiliki pengalaman yang baik serta selalu memberikan pelayanan prima hanya untuk anda.'
            ]
          },
          {
            id: 3,
            title: 'Ketersediaan Peralatan yang Modern',
            subtitle: [
              'Pastikan jasa yang anda pesan menggunakan peralatan membersihkan rumah yang modern dan bahan pembersih yang digunakan aman. Oleh karena itu, menggunakan alat modern pembersih rumah menjadi lebih berkualitas dan memberikan hasil pembersihan yang sehat. Dengan alat modern, membantu vendor dalam mengerjakan tugas membersihkan rumah anda, hal ini memberikan kenyamanan yang terjamin 100% bersih dari debu.'
            ]
          },
          {
            id: 4,
            title: 'Jadwal Yang Dapat Diatur Oleh Konsumen',
            subtitle: [
              'Menentukan pilihan untuk menggunakan suatu jasa yang dipanggil ke rumah, tentu harus memperhatikan waktu pengerjaannya. Dengan jadwal yang bisa diatur sendiri, anda dapat mengawasi pekerjaan vendor dalam bersih-bersih rumah dengan aman. Dengan memesan jasa cleaning di Halo Clean, anda bisa atur sendiri kapan dan jam berapa layanan bisa dilakukan. Oleh karena itu, tergantung kebutuhan anda dan vendor kami akan tepat waktu dan menjalankan tugas bersih-bersih rumah anda dengan efektif dan efisien. Berdasarkan kriteria tersebut, papat dilihat bahwa Halo Clean memberikan layanan yang dapat memenuhi kebutuhan anda khususnya pada layanan cleaning service panggilan. Jadi tidak perlu ragu lagi untuk memakai layanan Halo Clean.'
            ]
          }
        ]
      },
      {
        id: 3,
        title: 'Tips Menggunakan Jasa Cleaning Service',
        subtitle: [
          'Dalam memilih suatu jasa pembersihan rumah, anda harus jeli terlebih dahulu agar hasil dari penggunaan jasa tersebut menjadi lebih optimal. Berikut ini beberapa tips yang dapat membantu anda dalam menggunakan jasa Halo Clean :'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Beritahu Kebutuhan Anda Kepada Vendor Kami',
            subtitle: [
              'Jelaskan kepada vendor atau orang yang akan membersihkan rumah anda mengenai area dan jenis pembersihan yang dibutuhkan. tujuannya agar pengerjaan pembersihan rumah dapat menghasilkan ruangan yang maksimal dan menjaga agar barang yang ada di rumah anda tetap terjaga dan bersih walaupun menggunakan jasa bersih rumah panggilan.'
            ]
          },
          {
            id: 2,
            title: 'Beri Akses Yang Diperlukan Saja',
            subtitle: [
              'Anda dapat memberikan akses yang diperlukan untuk dibersihkan oleh kami dalam melakukan cleaning service yang akan membersihkan ruangan. Meskipun memberikan akses, tetapi bukan semata-mata tidak mengawasi secara lebih jauh untuk menjaga supaya seluruh barang berharga yang ada di rumah anda tidak hilang satupun.'
            ]
          },
          {
            id: 3,
            title: 'Periksa Hasil Layanan',
            subtitle: [
              'Cek hasil pembersihan untuk memastikan bahwa semua area telah dibersihkan dengan sempurna. Pastikan juga barang di rumah anda tidak hilang satupun. Sehingga anda bisa merasakan kebersihan kembali rumah yang nyaman dan bersih. Dengan memperhatikan setiap aspek, Halo Clean menjadi satu diantara banyaknya jasa yang menyediakan beres-beres rumah yang sangat cocok untuk anda. Selain memperhatikan setiap detail pembersihan, vendor juga memperhatikan seluruh barang berharga tetap aman dan utuh. Hal ini menjadi hal utama bagi kami, untuk membuat hidup anda makin bersih dan sehat.'
            ]
          }
        ]
      },
      {
        id: 4,
        title: 'Cara Memesan Jasa Cleaning Service di Halo Jasa',
        subtitle: [
          'Setelah kamu mengetahui jenis-jenis, kriteria, dan tips dalam memilih jasa cleaning servis panggilan. Kini saatnya anda menggunakan Halo Clean untuk merasakan kemudahan akses yang bisa membuat hidup anda menjadi lebih bersih dan sehat di rumah, anda dapat dengan mudah memesan cleaning service Halo Clean. anda bisa memesannya melalui aplikasi Halo Jasa yang dapat diunduh di google play store maupun apps store. Untuk dapat layanan Halo Clean di HaloJasa, kamu bisa memesan layanan dengan mengikuti langkah-langkah berikut ini :'
        ],
        subDetailContent: [
          {
            id: 1,
            subtitle: [
              'Unduh aplikasi Halo Jasa di Google Playstore atau App Store'
            ]
          },
          {
            id: 2,
            subtitle: ['Registrasi sesuai arahan dalam aplikasi Halo Jasa']
          },
          {
            id: 3,
            subtitle: ['Sesuaikan GPS kamu dengan lokasi saat ini']
          },
          {
            id: 4,
            subtitle: [
              'Dalam tampilan beranda, anda dapat memilih layanan Halo Clean untuk pemesanan order cleaning service panggilan'
            ]
          },
          {
            id: 5,
            subtitle: [
              'Lihat dan pilih layanan apa saja yang ditawarkan oleh Halo Clean sebagai bahan referensi dan kebutuhan'
            ]
          },
          {
            id: 6,
            subtitle: [
              'Kemudian untuk melihat proses pesanan. Kamu dapat mengklik “proses pesanan” dan masukkan tanggal dan lokasi pembersihannya'
            ]
          },
          {
            id: 7,
            subtitle: [
              'Lalu pilih metode pembayaran dan setelah itu klik “proses pemesanan”'
            ]
          },
          {
            id: 8,
            subtitle: [
              'Kamu dapat melihat proses pesananmu melalui laman pesanan dan tunggu konfirmasi dari vendor kami yang akan bersedia memberikan layanan pembersihan rumah anda,'
            ]
          }
        ]
      }
    ],
    footer:
      'Layanan home cleaning terbaik menjadi solusi untuk anda yang sibuk sampai tidak sempat untuk membereskan rumah. Halo Clean berusaha untuk memberikan layanan yang terbaik sehingga hasilnya dapat dirasakan dengan baik oleh anda. Memberikan kualitas dan pengalaman memukau adalah hal yang menjadi perhatian utama bagi kami sehingga kami berupaya untuk selalu memberikan pelayanan yang optimal dengan berbagai upaya seperti pelatihan, penyediaan alat-alat yang modern dan berkualitas. Jadi tunggu apalagi? Pesan Halo Clean sekarang untuk rasakan kenyamanan rumah anda.',
    links: {
      title: 'Halojasa Clean',
      detailLinks: [
        {
          id: 1,
          title: 'cleaning service tangerang',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-tangerang/'
        },
        {
          id: 2,
          title: 'cleaning service jakarta',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-jakarta/'
        },
        {
          id: 3,
          title: 'cleaning service tangsel',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-tangsel/'
        },
        {
          id: 4,
          title: 'cleaning service bogor',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-bogor/'
        },
        {
          id: 5,
          title: 'cleaning service kediri',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-kediri/'
        },
        {
          id: 6,
          title: 'cleaning service malang',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-malang/'
        },
        {
          id: 7,
          title: 'cleaning service bali',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-bali/'
        },
        {
          id: 8,
          title: 'cleaning service jember',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-jember/'
        },
        {
          id: 9,
          title: 'cleaning service bandung',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-bandung/'
        },
        {
          id: 10,
          title: 'cleaning service cikarang bekasi',
          link:
            'https://halojasa.com/jasa/jasa-cleaning-service-cikarang-bekasi/'
        },
        {
          id: 11,
          title: 'cleaning service yogya',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-yogya/'
        },
        {
          id: 12,
          title: 'cleaning service solo',
          link: 'https://halojasa.com/jasa/jasa-cleaning-service-solo/'
        }
      ]
    }
  },
  HF: {
    title:
      'Jasa Service AC Terlengkap Untuk Merawat Kesejukan Rumah Anda dengan Halo Fix',
    subtitle: [
      'Di bawah sinar matahari yang menyengat, tidak ada yang lebih menyegarkan daripada udara dingin yang dihasilkan oleh AC (Air Conditioner). Ketika musim panas tiba, AC menjadi penyelamat yang tak tergantikan di dalam rumah atau ruangan kerja. Jika digunakan terus menerus bisa mengakibatkan mesin AC jadi kurang optimal. Inilah mengapa layanan service AC menjadi begitu penting.',
      'Ketika AC digunakan secara terus menerus, maka kotoran, dan debu dapat menumpuk di dalamnya. Jika tidak dibersihkan secara teratur, ini bisa menyebabkan penurunan kualitas udara yang dikeluarkan oleh AC. Selain itu, filter yang kotor dapat membatasi aliran udara, memaksa AC untuk bekerja lebih keras dari biasanya, yang pada akhirnya dapat meningkatkan penggunaan listrik yang boros dan menyebabkan kerusakan pada sistem AC. Untuk mengatasi hal tersebut, hanya ada satu solusinya yaitu pesan Halo Fix. Halo fix memberikan layanan terbaik dalam proses service AC online yang memiliki keahlian khusus untuk menyelesaikan masalah AC. Dengan Halo Fix, kini anda tidak perlu repot lagi mencari teknisi handal yang dapat menyelesaikan masalah Air Conditioner (AC). Halo fix ini salah satu layanan terbaik dari aplikasi Halo Jasa yang memberikan pelayanan dalam service AC anda jadi makin optimal. Oleh karena itu, anda tak perlu khawatir jika AC di rumah atau apartemen bermasalah karena kini solusinya hanya satu, pesan Halo Fix aja.',
      'Layanan seperti apa saja dalam Halo Fix? Untuk anda yang pertama kali menggunakan jasa Halo Fix, anda dapat melihat jenis-jenis layanan hingga cara memesan Halo Fix dengan mudah yang ada dalam handphone anda.'
    ],
    detailContent: [
      {
        id: 1,
        title: 'Jenis Layanan Service AC ',
        subtitle: [
          'Jenis-jenis Layanan service AC di Halo Fix ada beberapa pilihan yang bisa anda pilih sesuai dengan kebutuhan dan masalah AC anda. Ini dia beberapa layanan service AC untuk rumah/kantor/apartement anda agar AC anda jadi lebih optimal.'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Cuci AC',
            subtitle: [
              'Menggunakan AC secara terus menerus tetapi tidak dirawat dengan baik maka yang terjadi adalah AC anda akan terlihat tampak tidak baik, kurang optimal dan perlu di bersihkan secara rutin. Halo Fix mempunyai jenis layanan yang membantu anda untuk membersihkan AC secara berkala. Dengan mencuci AC secara rutin, anda akan merasakan kenyamanan ruangan yang membuat lebih sejuk dan untuk menjaga kinerja AC Anda agar tetap optimal. Cara pembersihan AC bisa melalui pembersihan filter, periksaan gas refrigeran, dan pengecekan secara menyeluruh. Dengan selalu memcuci AC secara rutin, AC Anda akan bekerja dengan baik serta mengurangi kemungkinan kerusakan yang lebih serius di kemudian hari. Dengan menggunakan jasa Halo Fix, seluruh pengerjaan dilakukan dengan memperhatikan detail sehingga hasil pembersihan AC jadi lebih baik dan tidak mengganggu kinerja mesin AC.'
            ]
          },
          {
            id: 2,
            title: 'Pasang AC',
            subtitle: [
              'Bagi anda yang ingin memasang AC di rumah/kantor/apartement, tidak perlu khawatir mencari tukang pasang AC karena saat ini tersedia layanan terbaik yaitu pasang AC yang mudah di order dan terjamin pemasangannya. Dipasang oleh ahlinya, anda tidak perlu khawatir untuk hasil pemasangannya karena kami sangat memperhatikan detail setiap pengerjaan sehingga membantu agar hidup anda semakin nyaman dan sehat.'
            ]
          },
          {
            id: 3,
            title: 'Bongkar AC',
            subtitle: [
              'Layanan bongkar pasang AC ini memberikan pelayanan untuk anda ketika terjadi indikasi adanya kerusakan pada mesin AC anda. Dengan layanan ini, AC anda menjadi lebih optimal kembali. Dilakukan oleh teknisi professional, memberikan pelayanan terbaik, kenyamanan dan memastikan AC anda menjadi jauh lebih baik, dan menjamin kesejukannya.'
            ]
          }
        ]
      },
      {
        id: 2,
        title: 'Kriteria Jasa Service AC yang Baik',
        subtitle: [
          'Ketika memilih suatu jasa service panggilan ke dalam rumah anda, ada beberapa kriteria yang harus anda pertimbangkan terlebih dahulu agar saat anda mendapatkan layanan terbaik yang sesuai dengan kebutuhan Anda. Berikut ini beberapa kriteria yang bisa menentukan suatu jasa service AC yang baik :'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Periksa Reputasi Perusahaan',
            subtitle: [
              'Untuk anda yang pertama kali menggunakan layanan service AC panggilan ke rumah, anda harus memastikan terlebih dahulu reputasi perusahaan yang hendak digunakan. Hal ini perlu dilakukan untuk memastikan bahwa proses pengerjaan service AC sesuai dengan apa yang sudah di order. Halo Fix memberikan pelayanan terbaik sehingga anda dapat melihat reputasi perusahaan yang dapat meyakinkan anda bahwa Halo Fix adalah satu-satunya alternatif pilihan terbaik saat ini dengan segala kemudahan dengan satu klik saja.'
            ]
          },
          {
            id: 2,
            title: 'Sertifikat Teknisi',
            subtitle: [
              'Dalam dunia professional, tentu dibutuhkan sertifikat yang selaras dengan keahlian sebagai bukti nyata bahwa teknisi adalah seorang yang ahli dibidangnya. Halo Fix memastikan seluruh vendor telah memiliki sertifikat teknisi yang memadai serta melakukan tahap training atau pelatihan terlebih dahulu untuk memperkuat keahliannya dalam bidang service AC.'
            ]
          },
          {
            id: 3,
            title: 'Testimoni Pelanggan',
            subtitle: [
              'Sebelum memutuskan untuk menggunakan suatu jasa, anda dapat melihat terlebih dahulu testimoni dari pelanggan sebelumnya. Di Halo Fix, anda dapat melihat bagaimana pelanggan kami menerima seluruh layanan terbaik dengan hasil yang memuaskan dan menjadi rekomendasi untuk anda yang masih bingung menggunakan service AC terbaik dan langsung bisa dirasakan manfaatnya. Dengan kriteria diatas, dapat dilihat bahwa Halo Fix memberikan suatu layanan yang dapat memenuhi kebutuhan anda khususnya pada layanan service AC. Jadi tidak perlu ragu lagi untuk memakai layanan di Halo Fix sekarang juga.'
            ]
          }
        ]
      },
      {
        id: 3,
        title: 'Manfaat Menggunakan Jasa Service AC Profesional',
        subtitle: [
          'Melakukan pemilihan service AC profesional dari Halo Fix mempunyai sejumlah manfaat  bagi anda. Halo fix terbukti memudahkan anda mencari tukang service panggilan yang dapat anda lakukan ketika mendapatkan masalah pada AC rumah atau apartemen anda. Dengan layanan terbaik, Halo Fix menjadi salah satu solusi jasa professional khususnya dalam perbaikan AC di rumah anda. Beberapa di antara manfaat menggunakan Halo Fix :'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Kinerja AC yang Optimal',
            subtitle: [
              'Dengan perbaikan AC secara berkala, kinerja AC anda akan tetap optimal sehingga menghasilkan udara yang lebih segar, sehat dan lingkungan yang lebih sejuk. Dengan perawatan yang rutin, mesin AC anda akan bertahan bertahun-tahun.'
            ]
          },
          {
            id: 2,
            title: 'Hemat Biaya Jangka Panjang',
            subtitle: [
              'Dengan melakukan perbaikan secara teratur, Anda dapat menghindari kerusakan yang lebih serius dan memerlukan biaya perbaikan yang lebih mahal di kemudian hari. Dengan melakukan perawatan yang baik, akan menambah umur mesin AC jadi lebih panjang sehingga tidak perlu beli AC baru atau service terlalu mahal.'
            ]
          }
        ]
      },
      {
        id: 4,
        title: 'Perawatan Setelah Layanan',
        subtitle: [
          'Setelah anda mendapatkan layanan service AC terbaik dari Halo fix, ada beberapa tips sederhana yang dapat Anda lakukan untuk menjaga agar AC Anda tetap dalam kondisi yang optimal:'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Membersihkan Filter AC Secara Berkala',
            subtitle: [
              'Membersihkan filter AC secara teratur dapat membantu menjaga aliran udara yang bersih dan mengurangi risiko terkait masalah kinerja AC anda yang kurang optimal. Dengan melakukan ini secara rutin, mesin AC anda akan semakin berfungsi dengan baik dan tidak mudah rusak.'
            ]
          },
          {
            id: 2,
            title: 'Cek AC anda Secara Berkala',
            subtitle: [
              'Periksa secara rutin pada unit AC Anda untuk memastikan tidak ada masalah yang dapat muncul dikemudian hari. Ketika mendapati adanya indikasi kerusakan anda bisa langsung pesan service AC terbaik dari Halo Fix di aplikasi Halojasa dan dijamin AC anda akan optimal kembali.'
            ]
          }
        ]
      },
      {
        id: 5,
        title: 'Cara Memesan Jasa Service AC Secara Online di Halo Jasa',
        subtitle: [
          'Setelah mengetahui jenis-jenis layanan, kriteria memilih jasa service AC ke rumah, manfaat kinerja yang baik dan kemudahan service AC di Halo Fix. Kini anda dapat dengan mudah memesan service AC panggilan Halo Fix. Anda dapat memesan service AC  melalui aplikasi Halo Jasa yang dapat anda unduh di google play store maupun apps store. Berikut ini adalah tata cara memesan service AC di Halo Fix :'
        ],
        subDetailContent: [
          {
            id: 1,
            subtitle: ['Unduh aplikasi Halo Jasa di handphone anda']
          },
          {
            id: 2,
            subtitle: ['Registrasi untuk dapat login menggunakan akun anda']
          },
          {
            id: 3,
            subtitle: ['Sesuaikan GPS Handphone anda dengan lokasi saat ini.']
          },
          {
            id: 4,
            subtitle: [
              'Dalam tampilan beranda, anda dapat memilih layanan Halo Fix untuk pemesanan order.'
            ]
          },
          {
            id: 5,
            subtitle: [
              'Lihat dan pilih layanan apa saja yang ditawarkan oleh Halo Fix sebagai bahan referensi terbaik.'
            ]
          },
          {
            id: 6,
            subtitle: [
              'Jika anda ingin menambahkan layanan lainnya diluar paket yang tersedia, anda dapat memilih tambahan layanan dengan nominal tertera'
            ]
          },
          {
            id: 7,
            subtitle: [
              'Kemudian untuk memastikan proses pesanan. Anda dapat mengklik “proses pesanan” dan masukkan tanggal perbaikan serta lokasi perbaikan.'
            ]
          },
          {
            id: 8,
            subtitle: [
              'Lalu pilih metode pembayaran dan setelah itu klik “proses pemesanan”.'
            ]
          },
          {
            id: 9,
            subtitle: [
              'Anda dapat melihat proses pesanan melalui laman pesanan dan tunggu konfirmasi dari vendor kami yang akan bersedia memberikan layanan yang terbaik hanya untuk anda.'
            ]
          }
        ]
      }
    ],
    footer:
      'Dengan memanfaatkan layanan service on demand yang handal dari Halo Fix, anda dapat memastikan bahwa AC anda tetap berfungsi dengan baik sepanjang harinya. Pastikan untuk memilih Halo Fix dengan layanan yang sesuai dengan kebutuhan anda saat ini dan dengan harga yang sesuai dengan layanannya. Jangan lupa untuk mengikuti langkah-langkah perawatan setelah layanan untuk menjaga kinerja AC Anda tetap optimal.',
    links: {
      title: 'Halojasa Fix',
      detailLinks: [
        {
          id: 1,
          title: 'service ac panggilan tangerang',
          link: 'https://halojasa.com/jasa/jasa-service-ac-tangerang/'
        },
        {
          id: 2,
          title: 'service ac panggilan jakarta',
          link: 'https://halojasa.com/jasa/jasa-service-ac-jakarta/'
        },
        {
          id: 3,
          title: 'service ac panggilan tangsel',
          link: 'https://halojasa.com/jasa/jasa-service-ac-tangsel/'
        },
        {
          id: 4,
          title: 'service ac panggilan bogor',
          link: 'https://halojasa.com/jasa/jasa-service-ac-bogor/'
        },
        {
          id: 5,
          title: 'service ac panggilan depok',
          link: 'https://halojasa.com/jasa/jasa-service-ac-depok/'
        },
        {
          id: 6,
          title: 'service ac panggilan malang',
          link: 'https://halojasa.com/jasa/jasa-service-ac-malang/'
        },
        {
          id: 7,
          title: 'service ac panggilan jember',
          link: 'https://halojasa.com/jasa/jasa-service-ac-jember/'
        },
        {
          id: 8,
          title: 'service ac panggilan cikarang bekasi',
          link: 'https://halojasa.com/jasa/jasa-service-ac-bekasi/'
        },
        {
          id: 9,
          title: 'service ac panggilan yogya',
          link: 'https://halojasa.com/jasa/jasa-service-ac-yogya/'
        },
        {
          id: 10,
          title: 'service ac panggilan solo',
          link: 'https://halojasa.com/jasa/jasa-service-ac-solo/'
        },
        {
          id: 11,
          title: 'service ac panggilan kediri',
          link: 'https://halojasa.com/jasa/jasa-service-ac-kediri/'
        },
        {
          id: 12,
          title: 'service ac panggilan bandung',
          link: 'https://halojasa.com/jasa/jasa-service-ac-bandung/'
        },
        {
          id: 13,
          title: 'service ac panggilan bali',
          link: 'https://halojasa.com/jasa/jasa-service-ac-bali/'
        }
      ]
    }
  },
  HM: {
    title:
      'Jasa Reflexology Massage  Online 24 Jam dengan Terapis Berpengalaman dan Harga Terjangkau',
    subtitle: [
      'Jasa Reflexology Massage  merupakan layanan reflexology yang ditawarkan oleh Halo Jasa dengan berbagai kemudahan. Layanan ini akan memudahkan aktivitas untuk mendatangkan terapis profesional ke rumah Anda hanya melalui aplikasi.',
      'Bukan hanya layanan pijat relaksasi, home service massage  ini menawarkan sejumlah paket layanan yang dapat disesuaikan dengan kebutuhan Anda. Di antaranya adalah pijat tradisional, lulur, kerokan, refleksi, hingga mom & baby spa massage.',
      'Bagaimana dengan para terapis-nya? Apakah bisa dipercaya? Hal itu tentu sudah diantisipasi oleh Halo Jasa dengan sangat ketat. Seluruh tenaga jasa layanan reflexology di Halo Jasa telah diseleksi melalui berbagai jalur dan pelatihan profesional.',
      'Hal itu dilakukan oleh Halo Jasa untuk memberikan kenyamanan dan kepuasan bagi para pengguna layanan Jasa Reflexology Massage melalui aplikasi Halo Jasa. Apa sih, untungnya menggunakan layanan reflexology dari Halo Jasa?'
    ],
    detailContent: [
      {
        id: 1,
        title: 'Keuntungan Jasa Reflexology Massage',
        subtitle: [
          'Jasa Reflexology Massage di  sudah menjadi trend tersendiri. Pasalnya, hal itu akan mengefisiensi waktu dan aktivitas masyarakat urban dengan gaya hidupnya yang padat. Oleh karena itu, menemukan jasa massage panggilan terdekat menggunakan aplikasi tentu akan sangat memudahkan.',
          'Selain itu, apa saja keuntungan menggunakan layanan home service massage ? Berikut ini adalah sejumlah keuntungan yang dapat diperoleh dengan menggunakan layanan jasa reflexology panggilan .'
        ],
        subDetailContent: [
          {
            id: 1,
            title: 'Efisien dan Fleksibel',
            subtitle: [
              'Setelah melakukan berbagai aktivitas seharian penuh, Anda sebagai masyarakat urban, tentu ingin mengembalikan kebugaran untuk menghadapi esok hari. Salah satu caranya adalah dengan pijat atau reflexology.',
              'Namun, untuk kembali keluar rumah mendatangi tempat-tempat reflexology, Anda membutuhkan effort lebih lagi. Oleh karena itu, pemesanan jasa pijat  secara online melalui aplikasi dihadirkan Halo Jasa untuk Anda.',
              'Dengan begitu, Anda akan lebih dapat mengefisiensi waktu. Bahkan, Anda juga bisa memesan jasa reflexology secara fleksibel sesuai dengan waktu dan tempat yang Anda inginkan'
            ]
          },
          {
            id: 2,
            title: 'Kenyamanan',
            subtitle: [
              'Selain efisiensi dan fleksibilitas waktu, Anda juga akan memperoleh kenyamanan tersendiri dengan menggunakan layanan Jasa Reflexology Massage. Sebab, Anda tidak perlu pergi ke tempat SPA atau pusat pijat.',
              'Anda bisa menikmati reflexology di rumah atau hunian Anda sendiri. Apalagi, para terapisnya telah melalui berbagai seleksi vendor yang ketat, serta melakukan pelatihan profesional. Sehingga, Anda tak perlu ragu lagi dengan kualitas mereka.'
            ]
          },
          {
            id: 3,
            title: 'Kualitas',
            subtitle: [
              'Seperti yang sudah diketahui, para terapis di Halo Jasa telah melalui pelatihan sesuai dengan bidangnya, mulai dari pijat tradisional, SPA, lulur, creambath, totok, hingga mom & baby spa massage.',
              'Selain itu, para terapis telah dibekali dengan peralatan yang sesuai standar. Bahkan, Anda dapat memilih produk atau brand terbaik yang akan digunakan oleh para terapis. Dengan begitu, Anda tak perlu khawatir dengan penggunaan produk yang sensitif untuk Anda.'
            ]
          }
        ]
      },
      {
        id: 2,
        title: 'Manfaat Jasa Reflexology Massage di',
        subtitle: [
          'Tanpa perlu membuang-buang tenaga untuk pergi ke tempat pijat tradisional , layanan Jasa Reflexology Massage melalui Halo Jasa tentu memiliki beragam manfaat. Anda bisa menikmati reflexology hanya dengan rebahan saja di rumah.',
          'Anda tak perlu lagi menguras energi untuk mengantre di pusat-pusat SPA. Berikut adalah manfaat pijat bagi kebugaran tubuh.'
        ],
        subDetailContent: [
          {
            id: 1,
            subtitle: ['Mengatur tekanan darah dan mengurangi hipertensi.']
          },
          {
            id: 2,
            subtitle: [
              'Meningkatkan daya tahan tubuh, karena dapat meningkatkan produksi sel darah putih.'
            ]
          },
          {
            id: 3,
            subtitle: ['Mengurangi stress dan pusing berkepanjangan.']
          },
          {
            id: 4,
            subtitle: ['Meredakan rasa sakit karena otot tegang atau kram.']
          },
          {
            id: 5,
            subtitle: ['Melancarkan sirkulasi darah dalam tubuh.']
          }
        ],
        footer: [
          'Dengan berbagai manfaat tersebut, Anda bisa kembali menghadapi esok hari dengan penuh kesegaran'
        ]
      },
      {
        id: 3,
        title: 'Layanan Jasa Reflexology Massage',
        subtitle: [
          'Apa saja layanan Jasa Reflexology Massage yang tersedia di Halo Jasa? Tentu sangat beragam, Halo Jasa tidak hanya menyediakan jasa reflexology, akan tetapi menawarkan berbagai layanan lainnya. Berikut ini adalah sejumlah layanan massage  di Halo Jasa.'
        ],
        subDetailContent: [
          {
            id: 1,
            subtitle: ['Reflexology']
          },
          {
            id: 2,
            subtitle: ['Reflexy & Body Massage']
          },
          {
            id: 3,
            subtitle: ['Full Body Massage']
          },
          {
            id: 4,
            subtitle: ['Full Body Massage + Kerokan']
          },
          {
            id: 5,
            subtitle: ['Full Body Massage + Lulur']
          },
          {
            id: 6,
            subtitle: ['Full Massage + Totok + Masker Wajah']
          },
          {
            id: 7,
            subtitle: ['Full SPA Body Massage + Creambath']
          },
          {
            id: 8,
            subtitle: ['Full Body Massage + Dry Cupping']
          },
          {
            id: 9,
            subtitle: ['Hot Stone Massage']
          },
          {
            id: 10,
            subtitle: ['Sprain Massage']
          },
          {
            id: 11,
            subtitle: ['Pregnancy Massage']
          },
          {
            id: 12,
            subtitle: ['Mom & Baby SPA Massage']
          }
        ],
        footer: [
          'Berbagai layanan di atas, juga dapat Anda tambahkan layanan add on dengan harga tersendiri. Anda dapat mengecek selengkapnya di aplikasi Halo Jasa.',
          'Tak hanya paket reguler, Halo Jasa juga menawarkan layanan pijat  yang premium. Melalui layanan tersebut, Anda bisa menggunakan bahan dan peralatan yang lebih exclusive, misalnya menggunakan matras sekali pakai, atau produk-produk tertentu sesuai keinginan.'
        ]
      },
      {
        id: 4,
        title: 'Harga Jasa Reflexology Massage',
        subtitle: [
          'Hanya punya waktu senggang di tengah malam untuk refleksi? Anda tak perlu khawatir, Halo Jasa menawarkan kemudahan mendapatkan jasa Reflexology Massage 24 jam  dengan terapis yang profesional dan berpengalaman.',
          'Anda dapat memesan layanan pijat atau reflexology sesuai dengan kebutuhan Anda. Apakah ada terapis cowok panggilan ? Tentu saja, Halo Jasa bekerja sama dengan banyak vendor, baik laki-laki maupun perempuan melalui seleksi yang ketat dan pelatihan.',
          'Anda hanya perlu menggunakan aplikasi Halo Jasa untuk menemukan massage pria terdekat yang bisa datang ke rumah Anda. Jadi, mahal dong tarif Jasa Reflexology Massage di Halo Jasa? Tentu tidak, Anda dapat memilih paket harga yang sesuai dengan kebutuhan Anda.',
          'Berikut ini adalah harga reguler jasa reflexology panggilan  di Halo Jasa.',
          'Seluruh harga tersebut merupakan tarif layanan normal dari jam 06.00 AM – 22.00 PM dan sudah termasuk peralatan, transportasi, dan asuransi.',
          'Untuk mengetahui informasi selengkapnya terkait dengan harga masing-masing paket layanan Jasa Reflexology Massage  di Halo Jasa, dapat Anda cek langsung di aplikasi Halo Jasa.'
        ],
        subDetailContent: []
      }
    ],
    links: {
      title: 'Halojasa Massage',
      detailLinks: [
        {
          id: 1,
          title: 'pijat panggilan tangerang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-tangerang/'
        },
        {
          id: 2,
          title: 'pijat panggilan jakarta',
          link: 'https://halojasa.com/jasa/pijat-panggilan-jakarta/'
        },
        {
          id: 3,
          title: 'pijat panggilan tangsel',
          link: 'https://halojasa.com/jasa/pijat-panggilan-tangsel/'
        },
        {
          id: 4,
          title: 'pijat panggilan bogor',
          link: 'https://halojasa.com/jasa/pijat-panggilan-bogor/'
        },
        {
          id: 5,
          title: 'pijat panggilan depok',
          link: 'https://halojasa.com/jasa/pijat-panggilan-depok/'
        },
        {
          id: 6,
          title: 'pijat panggilan kuta bali',
          link: 'https://halojasa.com/jasa/pijat-panggilan-kuta-bali/'
        },
        {
          id: 7,
          title: 'pijat panggilan cikarang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-cikarang/'
        },
        {
          id: 8,
          title: 'pijat panggilan bekasi',
          link: 'https://halojasa.com/jasa/pijat-panggilan-bekasi/'
        },
        {
          id: 9,
          title: 'pijat panggilan cilegon',
          link: 'https://halojasa.com/jasa/pijat-panggilan-cilegon/'
        },
        {
          id: 10,
          title: 'pijat panggilan bandung',
          link: 'https://halojasa.com/jasa/pijat-panggilan-bandung/'
        },
        {
          id: 11,
          title: 'pijat panggilan cirebon',
          link: 'https://halojasa.com/jasa/pijat-panggilan-cirebon/'
        },
        {
          id: 12,
          title: 'pijat panggilan jember',
          link: 'https://halojasa.com/jasa/pijat-panggilan-jember/'
        },
        {
          id: 13,
          title: 'pijat panggilan surabaya',
          link: 'https://halojasa.com/jasa/pijat-panggilan-surabaya/'
        },
        {
          id: 14,
          title: 'pijat panggilan malang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-malang/'
        },
        {
          id: 15,
          title: 'pijat panggilan sidoarjo',
          link: 'https://halojasa.com/jasa/pijat-panggilan-sidoarjo/'
        },
        {
          id: 16,
          title: 'pijat panggilan bayuwangi',
          link: 'https://halojasa.com/jasa/pijat-panggilan-bayuwangi/'
        },
        {
          id: 17,
          title: 'pijat panggilan semarang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-semarang/'
        },
        {
          id: 18,
          title: 'pijat panggilan yogya',
          link: 'https://halojasa.com/jasa/pijat-panggilan-yogya/'
        },
        {
          id: 19,
          title: 'pijat panggilan solo',
          link: 'https://halojasa.com/jasa/pijat-panggilan-solo/'
        },
        {
          id: 20,
          title: 'pijat panggilan magelang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-magelang/'
        },
        {
          id: 21,
          title: 'pijat panggilan balikpapan',
          link: 'https://halojasa.com/jasa/pijat-panggilan-balikpapan/'
        },
        {
          id: 22,
          title: 'pijat panggilan pontianak',
          link: 'https://halojasa.com/jasa/pijat-panggilan-pontianak/'
        },
        {
          id: 23,
          title: 'pijat panggilan pekanbaru',
          link: 'https://halojasa.com/jasa/pijat-panggilan-pekanbaru/'
        },
        {
          id: 24,
          title: 'pijat panggilan palangkaraya',
          link: 'https://halojasa.com/jasa/pijat-panggilan-palangkaraya/'
        },
        {
          id: 25,
          title: 'pijat panggilan makassar',
          link: 'https://halojasa.com/jasa/pijat-panggilan-makassar/'
        },
        {
          id: 26,
          title: 'pijat panggilan manado',
          link: 'https://halojasa.com/jasa/pijat-panggilan-manado/'
        },
        {
          id: 27,
          title: 'pijat panggilan padang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-padang/'
        },
        {
          id: 28,
          title: 'pijat panggilan medan',
          link: 'https://halojasa.com/jasa/pijat-panggilan-medan/'
        },
        {
          id: 29,
          title: 'pijat panggilan palembang',
          link: 'https://halojasa.com/jasa/pijat-panggilan-palembang/'
        }
      ]
    }
  }
}

const serviceContentType = {
  HC: 'HC',
  HF: 'HF',
  HM: 'HM'
}

export default {
  serviceContent,
  serviceContentType
}
